/**
 * DEMO DISPLAY DATA — Sweet Futures client demo (2026-07-22).
 *
 * Strategies are sold per-unit ($100K–$200K unit equity, fixed contracts
 * per unit). There is NO pricing model in the database — this is a static,
 * hand-maintained lookup for the demo only. Do not wire this to real
 * billing/pricing logic; when a real pricing model exists, delete this file
 * and its call sites.
 *
 * Unit equities are demo placeholders:
 * - $100K for single-contract programs (ES or NQ variants alike)
 * - $150K for the multi-market wave-1 / wave-2 programs
 * - $200K for delta-sp (merged DLT+DST program)
 * - "Contact for pricing" for the bs-* (Black Swan) family and
 *   return-to-mean, which are not unit-priced for this demo
 */

export type DemoPricingTier = "Retail" | "Wholesale";

export interface DemoPricingEntry {
  /** Display string for per-unit equity, e.g. "$100K", or "Contact for pricing" */
  unitEquity: string;
  tierLabel: DemoPricingTier;
}

/** Keyed by strategy slug (see api/src/database/seeds/strategies.seed.ts). */
export const DEMO_PRICING: Record<string, DemoPricingEntry> = {
  "return-to-mean": { unitEquity: "Contact for pricing", tierLabel: "Wholesale" },
  "delta-sp": { unitEquity: "$200K", tierLabel: "Wholesale" },
  "vega-sp": { unitEquity: "$100K", tierLabel: "Retail" },
  "wave-1": { unitEquity: "$150K", tierLabel: "Wholesale" },
  "wave-2": { unitEquity: "$150K", tierLabel: "Wholesale" },
  "bs-atlas": { unitEquity: "Contact for pricing", tierLabel: "Wholesale" },
  "bs-aurora": { unitEquity: "Contact for pricing", tierLabel: "Wholesale" },
  "bs-gemini": { unitEquity: "Contact for pricing", tierLabel: "Wholesale" },
  "vector-apex-es": { unitEquity: "$100K", tierLabel: "Retail" },
  "vector-apex-nq": { unitEquity: "$100K", tierLabel: "Retail" },
  "gamma-range-es": { unitEquity: "$100K", tierLabel: "Retail" },
  "gamma-time-es": { unitEquity: "$100K", tierLabel: "Retail" },
};

/** Returns the demo pricing entry for a strategy slug, or undefined if not mapped. */
export function getDemoPricing(slug: string): DemoPricingEntry | undefined {
  return DEMO_PRICING[slug];
}
